<template lang="pug">
  v-app.asp-root(:class="tenantClass")
    router-view
    vue-snotify
    n-confirm-dialog(ref="confirm-dialog")

</template>

<script>
import { Vue, Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters } from 'vuex'
import consts from '@/store/common/consts'

@Component({
  computed: mapGetters([
    'authToken',
    'lastActionAt',
    'lastTokenRefreshAt',
    'tokenExpireInMinutes',
    'userTenantId'
  ]),

  methods: mapActions([
    'logout'
  ]),
})
export default class App extends Vue {
  @Watch('$route')
  onRouteChange (to, from) {
    if (!this.authToken && to && to.meta && !!to.meta.authNeeded) {
      if (this.$route.name !== 'login') {
        return this.$router.push({
          name: 'login'
        })
      }
    }
  }

  @Watch('authToken')
  onUpdateAuthToken (token) {
    if (!token && this.$route.name !== 'login') {
      return this.$router.push({
        name: 'login'
      })
    }
  }

  @Watch('userTenantId')
  onChangeUserTenant () {
    this.setThemeColor()
  }

  authTimer = null

  get tenantClass () {
    if (!this.userTenantId) {
      return ''
    }

    return `theme--${ this.userTenantId.toLowerCase() }`
  }

  mounted () {
    this.authTimer = setInterval(() => {
      this.checkLoginState()
    }, 1000)

    Vue.prototype.$confirmDialog = this.$refs['confirm-dialog']
    this.setThemeColor()
    // console.log(CSS.supports('position', 'sticky'))
  }

  beforeDestroy () {
    if (this.authTimer) {
      clearInterval(this.authTimer)
    }
  }

  checkLoginState () {
    if (!this.authToken || !this.$route.matched.find(r => r.meta.authNeeded)) {
      return
    }

    const timeNow = Math.floor(new Date() / 1000)
    const refreshTimeDiff = timeNow - (this.lastTokenRefreshAt || 0)
    const actionTimeDiff = timeNow - (this.lastActionAt || 0)

    if (
      (refreshTimeDiff / 60) >= this.tokenExpireInMinutes ||
      (actionTimeDiff / 60) >= this.tokenExpireInMinutes
    ) {
      console.log('time out!!!')
      this.logout()
    }
  }

  setThemeColor () {
    let theme = consts.THEME_VKB
    if (this.userTenantId === 'FSOEL') {
      theme = consts.THEME_FSOEL
    } else if (this.userTenantId === 'SAV') {
      theme = consts.THEME_SAV
    }

    this.$vuetify.theme.themes.light = theme
  }
}
</script>
